import styled from 'styled-components';

export const ItemWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  width: 100%;
`;

export const IconWrapper = styled.div`
  padding-top: 3px;
`;

export const StyledText = styled.div<{ $isProcessing?: boolean }>`
  color: ${({ $isProcessing }) =>
    $isProcessing ? 'var(--text-soft)' : 'var(--text-default)'};

  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  word-wrap: break-word;
  word-break: break-word;
`;
